"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIndexBuilder = void 0;
/**
 * create a object with zIndices
 *
    modal: {
      menubar: {
        nav: {},
        content: {
          nested: {}
        },

        bottom: {
          bottomNested: {}
        }
      }
    }

    =>

    {
      modal: 4,
      menubar: 3,
      nav: 2,
      content: 2,
      nested: 1,
      bottom: 2,
      bottomNested: 1
    }
 */
var ZIndexBuilder = /** @class */ (function () {
    function ZIndexBuilder(zIndexObj) {
        var _this = this;
        Object.defineProperty(this, "_zIndices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        var result = this.getFlattenKeys(zIndexObj);
        var maxZIndex = this.getMaxNestedNumber(result) + 1;
        result.forEach(function (item) {
            var splitted = item.split('.');
            var length = splitted.length;
            var key = splitted[length - 1];
            _this._zIndices[key] = maxZIndex - length;
        });
    }
    Object.defineProperty(ZIndexBuilder.prototype, "zIndices", {
        get: function () {
            return this._zIndices;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @param obj nested object { a: { b: {} } }
     * @param prefix key from parent, example a.b, prefix would be a
     * @param arr array from caller for recursive
     * @returns array of flatten keys, ['a', 'a.b']
     */
    Object.defineProperty(ZIndexBuilder.prototype, "getFlattenKeys", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (obj, prefix, arr) {
            var _this = this;
            var result = arr ? arr : [];
            Object.entries(obj).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (prefix) {
                    result.push(prefix + "." + key);
                    _this.getFlattenKeys(value, prefix + "." + key, result);
                }
                else {
                    result.push(key);
                    _this.getFlattenKeys(value, key, result);
                }
            });
            return result;
        }
    });
    /**
     * @param arr array with flatted object keys [root, root.nested, root.nested.nested1]
     * @returns maximum nested number, root.nested.nested1 -> 3
     */
    Object.defineProperty(ZIndexBuilder.prototype, "getMaxNestedNumber", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (arr) {
            var max = 0;
            arr.forEach(function (item) {
                var length = item.split('.').length;
                if (length > max) {
                    max = length;
                }
            });
            return max;
        }
    });
    return ZIndexBuilder;
}());
exports.ZIndexBuilder = ZIndexBuilder;
